(function() {
  'use strict';
  window.handleDiscountForm = function(event) {
    event.preventDefault();
    event.stopPropagation();   
    const getCartDrawer = document.querySelector('cart-drawer.active');
    const form = event.target;
    const input = form.querySelector('input[name="cart-discount-field"]'); 
    const error = form.querySelector('.cart-discount-form__error');
    const policeCheckboxWrapper = document.querySelector('policies-checkbox');
    const policeWarning = policeCheckboxWrapper?.querySelector('.policies-checkbox__warning');
    if (!input || !error) {
      return false;
    }
    const discountCode = input.value.trim();
    if (!discountCode || discountCode.length === 0) {
      error.style.display = 'block';
      return false;
    }
    error.style.display = 'none';    
    if(policeCheckboxWrapper && getCartDrawer){      
      const getInputCheckbox = policeCheckboxWrapper.querySelector('input[type="checkbox"]');
      if(getInputCheckbox.checked){        
        window.location.href = `/checkout?discount=${encodeURIComponent(discountCode)}`;
        if(policeWarning){
          policeWarning.style.display = 'none';
        }
        return false;
      }else{
        policeWarning.style.display = 'block';
      }
    }else{
      window.location.href = `/checkout?discount=${encodeURIComponent(discountCode)}`;
    }
  };
  window.handleDiscountFormChange = function(event) {
    const allErrors = document.querySelectorAll('.cart-discount-form__error');
    allErrors?.forEach((error) => {
      error.style.display = 'none';
    });
  };
  //   const form = event.target;
  //   const input = form.querySelector('input[name="cart-discount-field"]');
  //   const error = form.querySelector('.cart-discount-form__error');
  //   if (!input || !error) {
  //     return false;
  //   }
    

  //   const discountCode = input.value.trim();
  //   if (!discountCode || discountCode.length === 0) {
  //     error.style.display = 'block';
  //     return false;
  //   }
  //   error.style.display = 'none';
  //   window.location.href = `/checkout?discount=${encodeURIComponent(discountCode)}`;
  //   return false;
  // };
  // window.handleDiscountFormChange = function(event) {
  //   const allErrors = document.querySelectorAll('.cart-discount-form__error');
  //   allErrors.forEach((error) => {
  //     error.style.display = 'none';
  //   });
  // };
})();